import { useTenantCapability } from './tenant/feature';

/**
 * Show Settings > Manage Users > Rules? Only when the identity service's
 * capabilities of the active role say `rules` (Super Admins only, owner
 * decision 2026-10-15, admin-levels-2026-10-15.md). `active`: the settings
 * menu is shown (no call while it is closed).
 */
export function useSecurityRulesLink(active = true): boolean {
  return useTenantCapability('rules', active);
}
